export default __webpack_public_path__ + "static/media/CSV.89e73338.svg";